// Client-side "resolved length" estimator for templated strings.
//
// Length caps on authored strings count the raw input including placeholder
// tokens (`{suburb}`, `{gymInfo}`, etc.). The actual rendered string per
// location can be shorter (e.g. `{shortSuburb}` -> "Mt Druitt") or longer
// (`{gymInfo}` expands to a multi-line USP block). Authored length is what
// the schema caps; this helper gives authors an ESTIMATE of what the render
// would look like for a representative location so they can eyeball whether
// a template-heavy string is going to overflow platform limits at display.
//
// Averages are best-guesses from Wave 1 Snap data. Real render overflow is
// validated at AccountCampaign render time (P2b) per-location.

const AVERAGES: Record<string, number> = {
  accountName: 30,
  suburb: 12,
  shortSuburb: 8,
  suburbSlug: 14,
  slug: 30,
  state: 3,
  gymInfo: 200,
};

const PLACEHOLDER = /\{([a-zA-Z]+)\}/g;

export function estimateResolvedLength(input: string): number {
  let total = 0;
  let cursor = 0;
  let match: RegExpExecArray | null;
  PLACEHOLDER.lastIndex = 0;
  while ((match = PLACEHOLDER.exec(input)) !== null) {
    // Literal text before this placeholder.
    total += match.index - cursor;
    const avg = AVERAGES[match[1]!];
    if (avg === undefined) {
      // Unknown placeholder -- counts as its literal length (`{foo}` stays
      // literal in the rendered output per templating.ts).
      total += match[0].length;
    } else {
      total += avg;
    }
    cursor = match.index + match[0].length;
  }
  total += input.length - cursor;
  return total;
}

// Whether the input contains ANY placeholder token. Used by editors to decide
// if the resolved-estimate display is informative (skip it for plain strings).
export function hasPlaceholders(input: string): boolean {
  PLACEHOLDER.lastIndex = 0;
  return PLACEHOLDER.test(input);
}
